import clsx from "clsx";
import React from "react";
import { CgSpinner } from "react-icons/cg";
const FormSubmitButton = ({
  children,
  disabled,
  isSubmitting,
  full = false,
}) => {
  const isDisabled = isSubmitting || disabled;
  return (
    <button
      disabled={isDisabled}
      type="submit"
      className={clsx(
        full && "w-full",
        "flex justify-center items-center gap-2 rounded-md px-3 py-1.5 text-sm/6 font-semibold shadow-sm",
        isDisabled
          ? "bg-slate-300 text-slate-500 cursor-not-allowed"
          : "bg-amber-500 text-white hover:bg-amber-400",
        "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber-500"
      )}
    >
      {isSubmitting ? (
        <>
          <CgSpinner className="animate-spin h-5 w-5 mr-3" /> Memproses
        </>
      ) : (
        children
      )}
    </button>
  );
};

export default FormSubmitButton;
